'use strict'

import SurveyList from '@/pages/Survey/SurveyList.vue'
import Survey from '@/pages/Survey/Survey.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/surveys',
    name: 'Surveys',
    component: SurveyList,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/surveys/:id',
    name: 'Survey',
    component: Survey,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/survey.js